import { getUserData } from '@/auth/utils'
import { $themeConfig } from '@themeConfig'
import appConstants from '@/constants/constants'

export const getAvatarSrc = () => {
  const userData = getUserData()
  return userData && userData.avatar ? userData.avatar : null
}

export const getLogoSrc = () => {
  const userData = getUserData()
  let logo = $themeConfig.app.appLogoHorizontalProfmanHealth
  if (userData && userData.logo_svg && userData.logo_svg.url) {
    logo = userData.logo_svg.url
  } else if (userData && userData.program_version === 'profman_dental') {
    logo = $themeConfig.app.appLogoHorizontalProfmanDental
  }
  return logo
}

export const getLogoPng = () => {
  const userData = getUserData()
  return userData && userData.logo_png && userData.logo_png.url ? userData.logo_png : null
}

export const getId = () => {
  const userData = getUserData()
  return userData && userData.id ? userData.id : null
}

export const getRoleType = () => {
  const userData = getUserData()
  return userData && userData.role_type ? userData.role_type : null
}

export const getFirstName = () => {
  const userData = getUserData()
  return userData && userData.first_name ? userData.first_name : null
}

export const getSystemModules = () => {
  const userData = getUserData()
  return userData && userData.system_modules ? userData.system_modules : []
}

export const getIntegratorBranchId = () => {
  const userData = getUserData()
  return userData && userData.integrator_branch_id ? userData.integrator_branch_id : null
}

export const getIntegratorId = () => {
  const userData = getUserData()
  return userData && userData.integrator_id ? parseInt(userData.integrator_id) : 0
}

export const getIntegratorName = () => {
  const userData = getUserData()
  return userData && userData.integrator_name ? userData.integrator_name : null
}

export const getIntegratorWorkTimeFrom = () => {
  const userData = getUserData()
  return userData && userData.integrator_work_time_from ? userData.integrator_work_time_from : 480
}

export const getIntegratorWorkTimeTo = () => {
  const userData = getUserData()
  return userData && userData.integrator_work_time_to ? userData.integrator_work_time_to : 1310
}

export const getProgramVersionLogo = () => {
  const userData = getUserData()
  return userData && userData.program_version === 'profman_dental'
    ? $themeConfig.app.appLogoProfmanDental
    : $themeConfig.app.appLogoProfmanHealth
}

export const getProgramVersionLogoWidthPX = () => {
  const userData = getUserData()
  return userData && userData.program_version === 'profman_dental' ? 670 : 1418
}

export const getProgramVersionLogoHeightPX = () => {
  const userData = getUserData()
  return userData && userData.program_version === 'profman_dental' ? 624 : 512
}

export const getProgramVersionName = () => {
  const userData = getUserData()
  return userData && userData.program_version === 'profman_dental'
    ? $themeConfig.app.appNameProfmanDental : $themeConfig.app.appNameProfmanHealth
}

export const integratorIsDentalLaboratory = () => {
  const userData = getUserData()
  return !!(
    userData && [
      appConstants.integrator.type.DENTAL_LABORATORY, appConstants.integrator.type.CLINIC_DENTAL_LABORATORY
    ].includes(userData.integrator_type)
  )
}

export const integratorIsClinic = () => {
  const userData = getUserData()
  return !!(
    userData && [
      appConstants.integrator.type.CLINIC, appConstants.integrator.type.CLINIC_DENTAL_LABORATORY
    ].includes(userData.integrator_type)
  )
}

export const integratorIsClinicAndDentalLaboratory = () => {
  const userData = getUserData()
  return !!(
    userData && userData.integrator_type === appConstants.integrator.type.CLINIC_DENTAL_LABORATORY
  )
}

export const currentUserIsDoctor = () => {
  const roleType = getRoleType()
  return !!(roleType && roleType === appConstants.role.type.DOCTOR)
}

export const currentUserIsRoot = () => {
  const roleType = getRoleType()
  return !!(roleType && roleType === appConstants.role.type.ROOT)
}

export const currentUserIsSysAdmin = () => {
  const roleType = getRoleType()
  return !!(roleType && roleType === appConstants.role.type.SYS_ADMIN)
}

export const currentUserIsAdmin = () => {
  const roleType = getRoleType()
  return !!(roleType && roleType === appConstants.role.type.ADMIN)
}

export const currentUserIsSupport = () => {
  const roleType = getRoleType()
  return !!(roleType && roleType === appConstants.role.type.SUPPORT)
}

export const subscriptionExpirationDate = () => {
  const userData = getUserData()
  return userData ? userData.subscription_expired_at : null
}

export const subscriptionMonthPrice = () => {
  const userData = getUserData()
  return userData && userData.subscription_month_price ? userData.subscription_month_price : null
}

export const getUserAbilities = () => {
  const userData = getUserData()
  return userData && userData.ability && userData.ability.length ? userData.ability : []
}

export const userHasModule = moduleName => {
  let available = false
  const user = getUserData()
  if (user) {
    if (user.isRoot) {
      available = true
    }
    available = user.system_modules.includes(moduleName)
  }
  return available
}
